import StorboltEcommerceComponent from "screens/partials/ecommerce";
import MainLayout from "screens/partials/layout";

export default function Home() {
    return (
        <MainLayout>
            <StorboltEcommerceComponent />
        </MainLayout>
    )
}